module.exports = __webpack_public_path__ + "static/redapple_Final_Lightgray-87c71c0a62ebe62c30ec92ce229bcfc1.png";